import React from 'react';
import classnames from 'classnames';
import { Classes, HTMLInputProps, IInputGroupProps, InputGroup } from '@blueprintjs/core';
import { TranslatedMessage } from '../../translation';
import { Overwrite } from '../../../../typings/typings';
import { TLCode } from '../../../../common/enums';

interface CommonInputProps extends IInputGroupProps {
  fill?: boolean;
}

export type InputProps = Overwrite<CommonInputProps, { placeholder?: TLCode | string }> &
  Overwrite<HTMLInputProps, { placeholder?: TLCode | string }>;

const renderInputGroup = ({
  fill = true,
  className,
  ...otherInputGroupProps
}: CommonInputProps & HTMLInputProps = {}) => (
  <InputGroup {...otherInputGroupProps} className={classnames(className, { [Classes.FILL]: fill })} />
);

class Input extends React.Component<InputProps> {
  render() {
    const { placeholder, ...otherProps } = this.props;
    return typeof placeholder === 'number' ? (
      <TranslatedMessage id={placeholder as TLCode}>
        {(tanslatedPlaceholder) => renderInputGroup({ ...otherProps, placeholder: tanslatedPlaceholder })}
      </TranslatedMessage>
    ) : (
      renderInputGroup({ ...otherProps, placeholder: placeholder as string })
    );
  }
}

export default Input;
